const DEFAULT_NO_FREIGHT_CONFIG = {
  enableNoFreightCode: false,
  enforceNoFreightReasonCodeIfExists: false,
  enableNoFreightOutsidePickupWindow: false,
};

export const parseNoFreightConfig = (rawConfig) => {
  if (!rawConfig || typeof rawConfig !== 'string') {
    return DEFAULT_NO_FREIGHT_CONFIG;
  }

  try {
    return JSON.parse(rawConfig);
  } catch (_error) {
    return DEFAULT_NO_FREIGHT_CONFIG;
  }
};

